<template>
    <div class="base-bill" :class="{'bill-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="back-img" @click="$router.back()">
                <img class="back" src="~images/back.png" />
            </div>
            <div class="title">账单记录</div>
            <div class="service-img" @click="$router.push('/base-service')">
                <img class="ser" src="~images/user_service.png" />
            </div>
        </div>
        <div class="content">
            <div class="totalize" v-if="list.length > 0">
                <div>共计充值：￥{{ptb_sum}}</div>
                <div>共计消费：￥{{pay_sum}}</div>
            </div>
            <div>
                <div v-if="isblank == true">
                    <div class="list" v-for="(item, index) in list" :key="index">
                        <div class="top">
                            <div>订单号：{{item.orderid}}</div>
                            <div>
                                <span v-if="item.payType == 1 || item.payType == 2 || item.payType == 11">支付宝支付</span>
                                <span v-if="item.payType == 3 || item.payType == 4">微信支付</span>
                                <span v-if="item.payType == 10">平台币支付</span>
                            </div>
                        </div>
                        <div class="bottom">
                            <div class="left">
                                <img src="~images/pay_1.png" v-if="item.payType == 1 || item.payType == 2 || item.payType == 11" />
                                <img src="~images/pay_2.png" v-if="item.payType == 3 || item.payType == 4" />
                                <img src="~images/pay_3.png" v-if="item.payType == 10" />
                                <div class="detl">
                                    <div class="con">{{item.productNAME}}</div>
                                    <div class="time">{{item.create_time}}</div>
                                </div>
                            </div>
                            <div class="pay-money" :class="{isgreen: item.payMode != 1}">
                                <span v-if="item.payMode == 1">-{{item.money}}</span>
                                <span v-else>+{{item.money}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="theblank" v-if="isblank == false">
                    <TheBlank />
                </div>
                <div class="ddbottom" ref="bottomScroll"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import TheBlank from '@/components/TheBlank'

    export default {
        // 进入路由之前
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.getBill()
            })
        },
        name: 'BaseBill',
        components: {
            TheBlank
        },
        data () {
            return {
                list: [],
                isisbool: true,
                accountData: {},
                pageNum: 1,
                pageCount: 0,
                pay_sum: 0,
                ptb_sum: 0,
                isblank: null,
                // h5LoginData:{}   //＋
            }
        },
        methods: {
            // 获取账单列表
            getBill () {
                let options = {
                    appid: this.accountData.appid,
                    uid: this.accountData.uid,
                    page: this.pageNum
                };
                options.sign = this.util.getSign(options, this.accountData.appkey)
                this.$axios.post('https://sdk.gameschain.pro/index.php?g=api&m=user&a=pay_list_by_user', this.$qs.stringify(options)).then(res => {
                    if (res.data.status == 1) {
                        this.isisbool = true
                        this.list = [...this.list, ...res.data.data.list]
                        this.pageCount = res.data.data.count
                        this.pay_sum = res.data.data.pay_sum
                        this.ptb_sum = res.data.data.ptb_sum
                        this.isblank = this.list.length > 0 ? true : false
                    }
                })
            },
            handleScroll () {
                let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
                if (this.$refs.bottomScroll) {
                    let bottom = Number.parseInt((this.$refs.bottomScroll.getBoundingClientRect().bottom).toFixed(0))
                    if (bottom < windowHeight + this.$refs.bottomScroll.clientHeight && this.isisbool) {
                        this.isisbool = false
                        if (this.pageNum < this.pageCount) {
                            this.pageNum = this.pageNum + 1
                            this.getBill()
                        }
                    }
                }
            }
        },
        created () {
            this.accountData = JSON.parse(sessionStorage.getItem('accountData'))
            // this.h5LoginData = JSON.parse(sessionStorage.getItem('h5LoginData'))
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll, true)
        },
        destroyed () {
            window.removeEventListener('scroll', this.handleScroll)
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22;
    // 横屏css
    .base-bill {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .back-img {
                width: 192px;
                height: 132px;
                position: absolute;
                left: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .back {
                    width: 72px;
                    height: 72px;
                }
            }
            .title {
                font-size: 51px;
                text-align: center;
            }
            .service-img {
                width: 192px;
                height: 132px;
                position: absolute;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .ser {
                    width: 72px;
                    height: 72px;
                }
            }
        }
        .content {
            flex: 1;
            overflow-y: scroll;
            padding: 40px 60px 60px;
            position: relative;
            .totalize {
                color: rgba(255, 255, 255, 0.5);
                font-size: 36px;
                padding: 0 70px;
                margin-bottom: 40px;
                display: flex;
                justify-content: space-evenly;
            }
            .list {
                min-height: 225px;
                border-radius: 18px;
                background: rgba(255, 255, 255, 0.2);
                padding: 0 45px;
                margin-bottom: 30px;
                display: flex;
                flex-direction: column;
                .top {
                    height: 60px;
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 27px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .bottom {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .bottom .left {
                    display: flex;
                    align-items: center;
                }
                .bottom .left img {
                    width: 105px;
                    height: 105px;
                    margin-right: 30px;
                }
                .bottom .left .detl {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                .bottom .left .detl .con {
                    max-width: 600px;
                    font-size: 45px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: relative;
                    top: -5px;
                }
                .bottom .left .detl .time {
                    font-size: 36px;
                    color: rgba(255, 255, 255, 0.5);
                }
                .pay-money {
                    color: #FF3333;
                    font-size: 48px;
                }
                .isgreen {
                    color: #48A253;
                }
            }
            .list:last-child {
                margin-bottom: 0;
            }
            .ddbottom {
                height: 60px;
                margin-bottom: -60px;
            }
            .theblank {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    // 竖屏css
    .bill-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            border-radius: 60px 0 0 0;
            .back-img {
                width: 290px;
                height: 240px;
                .back {
                    width: 130px;
                    height: 130px;
                }
            }
            .title {
                font-size: 92px;
            }
            .service-img {
                width: 290px;
                height: 240px;
                .ser {
                    width: 130px;
                    height: 130px;
                }
            }
        }
        .content {
            padding: 72px 90px 90px;
            .totalize {
                font-size: 65px;
                padding: 0 127px;
                margin-bottom: 72px;
            }
            .list {
                min-height: 409px;
                border-radius: 32px;
                padding: 0 60px;
                margin-bottom: 54px;
                .top {
                    height: 120px;
                    font-size: 49px;
                }
                .bottom .left img {
                    width: 190px;
                    height: 190px;
                    margin-right: 54px;
                }
                .bottom .left .detl .con {
                    max-width: 800px;
                    font-size: 70px;
                    top: -9px;
                }
                .bottom .left .detl .time {
                    font-size: 60px;
                }
                .pay-money {
                    font-size: 87px;
                }
            }
            .ddbottom {
                height: 90px;
                margin-bottom: -90px;
            }
        }
    }
</style>